import { Component, OnInit, afterNextRender, inject, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PrimeNG } from 'primeng/config';
import { Title } from '@angular/platform-browser';
import { environment } from '../environments/environment';
import { primeDe } from '@shared';
import { ThemeService } from '@shared/theme';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterOutlet],
})
export class AppComponent implements OnInit {
  private primeng = inject(PrimeNG);
  private titleService = inject(Title);
  private themeService = inject(ThemeService);

  constructor() {
    afterNextRender(() => this.themeService.restoreFromStorage());
  }

  ngOnInit() {
    this.primeng.setTranslation(primeDe.de);
    this.titleService.setTitle(
      `BENZ Cloud Admin | V${environment.appVersion} | ${environment.env}`,
    );
  }
}
